module.exports = __webpack_public_path__ + "img/barcode.a6623ea5.svg";